<template>
    <div class="w-full md:w-2/3 bg-white min-h-full md:pt-6 md:pb-8 px-4 md:px-8">
        
        <div class="flex justify-between items-center pb-2">
            <div class="hidden md:block">
                <span class="text-blue-600 font-medium">{{ this.keyword }}</span>에 대한 검색 결과, 총 <span class="text-blue-600 ibm font-medium">{{ model.ptlNum }}</span>개의 포털에서 <span class="text-blue-600 ibm font-medium">{{ model.dataNum.toLocaleString('ko-KR') }}</span>건의 데이터가 검색되었습니다.
            </div>

            <!-- <div class="flex text-xs border">
                <button type="button" @click="sortByIssuedDate" class="px-3 py-1.5 border-r focus:bg-zinc-100">등록 순</button>
                <button type="button" @click="sortByView" class="px-3 py-1.5 border-r focus:bg-zinc-100">조회 순</button>
                <button type="button" @click="sortByDownload" class="px-3 py-1.5 focus:bg-zinc-100">다운로드 순</button>
            </div> -->
        </div>

        <div v-if="this.model.results">
            <div v-for="(result, idx) in this.model.results" v-bind:key="idx" class="py-3 md:py-5">
                <div>
                    <div class="flex items-center pb-2">
                        <a :href="result['_source']['accessURL']" target="_blank">
                            <div class="text-base md:text-lg font-medium alink-text pr-3">
                                {{ result['_source']['datasetLabel'] }}
                            </div>
                        </a>
                        <div class="text-xs px-1.5 py-1 bg-blue-100 text-blue-800 drop-shadow-sm mr-1">
                            <a :href="`${result['_source']['datasetURI']}`" target="_blank">
                                Graph
                            </a>
                        </div>
                        <div class="text-xs px-1.5 py-1 bg-blue-100 text-blue-800 drop-shadow-sm">
                            <a :href="`https://labs.datahub.kr/projects/lodlive?${result['_source']['dataset']}`" target="_blank">
                                View
                            </a>
                        </div>
                    </div>
                    <div v-if="result['_source']['description'] && result['_source']['description'].length < 200" class="text-sm text-gray-700 pb-2 mb-2">
                        <a :href="result['_source']['accessURL']" target="_blank">
                            {{ result['_source']['description'] }}
                        </a>
                    </div>
                    <div v-else-if="result['_source']['description'] && result['_source']['description'].length >= 200" class="text-sm text-gray-700 pb-2 mb-2">
                        <a :href="result['_source']['accessURL']" target="_blank">
                            {{ result['_source']['description'].substring(0,200)+"∙∙∙" }}
                        </a>
                    </div>
                    <div class="text-gray-500 text-sm">
                        <ul class="flex flex-wrap">
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                포털: 
                                <span v-if="result['_source']['datamapLabel']">
                                    <a :href="`${portalLink[result['_source']['datamapURI']]['href']}`" target="_blank" class="underline underline-offset-1" >
                                        {{ result['_source']['datamapLabel'] }}
                                    </a>
                                </span>
                                <span v-else> -</span>
                            </li>

                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                제공기관: 
                                <span v-if="(checkOrg(result['_source']['publisherURI']) == true)">
                                    <a :href="`${orgLink[result['_source']['publisherURI']]['href']}`" target="_blank" class="underline underline-offset-1" >
                                        {{ result['_source']['publisherLabel'] }}
                                    </a>
                                </span>
                                <span v-else-if="result['_source']['publisherURI']">{{ result['_source']['publisherLabel'] }}</span>
                                <span v-else> -</span>
                            </li>
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                등록일: 
                                <span v-if="result['_source']['modifiedDate']" class="ibm">{{ result['_source']['modifiedDate'] }}</span>
                                <span v-else> -</span>
                            </li>
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                분류체계: 
                                <span v-if="result['_source']['categoryLabel']">{{ result['_source']['originalCategoryLabel'] }}</span>
                                <span v-else> -</span>
                            </li>
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                확장자: 
                                <span v-if="result['_source']['formatLabel']" class="ibm">{{ result['_source']['formatLabel'] }}</span>
                                <span v-else> -</span>
                            </li>
                        </ul>
                        <ul class="flex flex-wrap">
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                조회수: 
                                <span v-if="result['_source']['numView']" class="ibm">{{ result['_source']['numView'].toLocaleString('ko-KR') }}</span>
                                <span v-else> -</span>
                            </li>
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                다운로드수:
                                <span v-if="result['_source']['numDown']" class="ibm">{{ result['_source']['numDown'].toLocaleString('ko-KR') }}</span>
                                <span v-else> -</span>
                            </li>
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                DPV:
                                <span v-if="result['_source']['dpv']" class="imb">{{ mathRound(result['_source']['dpv'])}}</span>
                                <span v-else> -</span>
                            </li>
                            <!-- <li v-if="result['_source']['dpv']" class="mr-4 mb-3">DPV: <span class="ibm">{{ mathRound(result['_source']['dpv']) }}</span></li>
                            <li v-else class="mr-4 mb-3">DPV: -</li> -->
                            <li class="mr-2 mb-1.5 md:mr-4 md:mb-3">
                                데이터 완전성: 
                                <span v-if="result['_source']['dqvValue']" class="ibm">{{ result['_source']['dqvValue'] }}</span>
                                <span v-else> -</span>
                            </li>
                            <!-- <div v-if="result['_source']['licenseLabel']" class="ibm mr-4 mb-2">
                                라이선스: <a :href="result['_source']['licenseURI']" target="_blank" class="underline underline-offset-1">{{ result['_source']['licenseLabel'] }}</a>
                            </div>   -->
                        </ul>
                    </div>
                    <!-- 접은 상태 -->
                    <div v-if="this.model.colChkList">
                        <div v-if="(this.localcolChkList[idx] == false)" class="mr-2 md:mr-4">
                            <div v-if="(result['_source']['columnList'].length > 0)" class="inline text-sm pr-2 text-gray-500 py-1">컬럼:</div>
                            <div v-for="i in result['_source']['columnList'].slice(0,5)" v-bind:key="i" class="inline-flex items-center px-1.5 py-1 mr-1.5 text-xs bg-zinc-100 drop-shadow-sm text-zinc-700 mb-1">{{ i }}</div>
                            <button v-if="(result['_source']['columnList'].length > 5)" @click="buttonOnOff(idx)" class="inline-flex items-center px-1.5 py-1 mr-1.5 text-xs border drop-shadow-sm text-zinc-700 mb-1">더 보기</button>
                        </div>
                        <!-- 펼친 상태 -->
                        <div v-if="(this.localcolChkList[idx] == true)" class="mr-4 mb-2">
                            <div v-if="(result['_source']['columnList'].length > 0)" class="inline text-sm pr-2 text-gray-500 py-1">컬럼:</div>
                            <div v-for="i in result['_source']['columnList']" v-bind:key="i" class="inline-flex items-center px-1.5 py-1 mr-1.5 text-xs bg-zinc-100 drop-shadow-sm text-zinc-700 mb-1">{{ i }}</div>
                            <button v-if="(result['_source']['columnList'].length > 0)" @click="buttonOnOff(idx)" class="inline-flex items-center px-1.5 py-1 mr-1.5 text-xs border drop-shadow-sm text-zinc-700 mb-1">접기</button>
                        </div>
                    </div>

                </div>
                <!-- <div class="flex gap-x-2 py-2">
                    <div v-if="result['_source']['categoryLabel']" class="flex gap-x-2 text-xs">
                        <div class="block px-2.5 py-1.5 bg-zinc-100 drop-shadow-sm text-zinc-700">{{ result['_source']['originalCategoryLabel'] }}</div>
                    </div>
                    <div v-if="result['_source']['formatLabel']" class="flex gap-x-2 text-xs">
                        <div class="block px-2.5 py-1.5 bg-zinc-100 drop-shadow-sm text-zinc-700">{{ result['_source']['formatLabel'] }}</div>
                    </div>
                    <div v-if="result['_source']['publishertypeLabel']" class="flex gap-x-2 text-xs">
                        <div class="block px-2.5 py-1.5 bg-zinc-100 drop-shadow-sm text-zinc-700">{{ result['_source']['publishertypeLabel'] }}</div>
                    </div>
                    <div v-if="result['_source']['licenseLabel']" class="flex gap-x-2 text-xs">
                        <div class="block px-2.5 py-1.5 bg-zinc-100 drop-shadow-sm text-zinc-700">{{ result['_source']['licenseLabel'] }}</div>
                    </div>
                </div> -->
            </div> 
        </div>

    </div>
</template>

<style>
.text-mid {
    font-size: 0.84rem;
    line-height: 0.85rem;
}
</style>

<script>
import portal from "@/assets/dashboard-portal.json"
import org from "@/assets/dashboard-org.json"

const portalLink = portal;
const orgLink = org;
const orgList = Object.keys(orgLink);

export default {
    name: "SearchResult",
    props: {
        model: Object,
        // filModel: Object,
    },
    data() {
        return {
            filteredID: {},
            // localcolChkList: [],
            keyword: "미세먼지",
            portalLink,
            orgLink,
            orgList
        }
    },
    mounted() {
        if (this.$route.query.q) {
            this.keyword = this.$route.query.q
        }
        // console.log(this.model)
    },
    computed: {
        localcolChkList() {
            // console.log("computed-colChkList", this.model.colChkList);
            return this.model.colChkList;
        },
    },
    methods: {
        buttonOnOff(idx) {
            this.localcolChkList[idx] = !this.localcolChkList[idx];
        },
        checkOrg(uri) {
            var URI = String(uri)
            if (orgList.includes(URI)) {
                // console.log("orgLink", this.orgLink[uri]['href'])
                return true;
            } else {
                // console.log(uri)
                return false;
            }
        },
        mathRound(num) {
            return Math.round(num * 10000) / 10000;
        },
        mathFloor(num) {
            return Math.floor(num);
        },
        // sortByIssuedDate() {
        //     this.dsList.sort((a, b) => {
        //         return new Date(b['_source']['등록']) - new Date(a['_source']['등록']);
        //     });
        // },
        // // TODO: 조회 항목 있는지 보고 sort 진행
        // sortByView() {
        //     this.dsList.sort((a, b) => {
        //         return b['_source']['조회'] - a['_source']['조회'];
        //     });
        // },
        // // TODO: 다운로드 항목 있는지 보고 sort 진행
        // sortByDownload() {
        //     this.dsList.sort((a, b) => {
        //         return b['_source']['다운로드'] - a['_source']['다운로드'];
        //     });
        // }
    },
} 
</script>
